import { render } from "./StatisticsReport.vue?vue&type=template&id=5803928d&scoped=true"
import script from "./StatisticsReport.vue?vue&type=script&lang=js"
export * from "./StatisticsReport.vue?vue&type=script&lang=js"

import "./StatisticsReport.vue?vue&type=style&index=0&id=5803928d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5803928d"]])

export default __exports__